// extracted by mini-css-extract-plugin
export default {"div":"Divider_div__1wTVm","hr":"Divider_hr__cqjem","textRed":"Divider_textRed__JxPMX"};